import React, { useState, useContext } from 'react'
import { CognitoIdentityProviderClient, InitiateAuthCommand } from "@aws-sdk/client-cognito-identity-provider"
import CloudformationOutputs from '../CloudformationOutputs.json'
import { GlobalContext } from '../GlobalContext'
import Button from '../formfields/Button'
import Password from './auth_formfields/Password'
import Text from './auth_formfields/Text'
import { Link, useNavigate } from 'react-router-dom'

type Props = {
    authChallenge: ObjectStringKeyAnyValue | null
    setAuthChallenge: React.Dispatch<React.SetStateAction<any>>
    setShowForm: React.Dispatch<React.SetStateAction<any>>
}


function LoginForm({
    authChallenge,
    setAuthChallenge,
    setShowForm
}: Props) {

    const {
        socket,
        setShowModal,
        sendMessageToWebsocket,
        setShowLoginModal
    } = useContext(GlobalContext)

    const navigate = useNavigate()
    const [formFields, setFormFields] = useState<ObjectStringKeyAnyValue>({})
    const [formErrors, setFormErrors] = useState<ObjectStringKeyAnyValue>({})


    const validate = () => {
        let isValid = true
        const emailRegex = new RegExp("^.+@.+")
        const newFormErrors: ObjectStringKeyAnyValue = {}

        if (
            !formFields["emailAddress"] ||
            !emailRegex.test(formFields["emailAddress"])
        ) {
            isValid = false
            newFormErrors["emailAddress"] = 'Please enter a valid email address'
        }

        if (!formFields['password']) {
            isValid = false
            newFormErrors["password"] = 'Please enter a password'

        }
        setFormErrors(newFormErrors)
        return isValid
    }




    const validateAndSave = () => {
        const isValid = validate()
        if (isValid) {
            setShowLoginModal(true)
            const client = new CognitoIdentityProviderClient({ region: CloudformationOutputs['AWSRegion'] })
            const username = formFields["emailAddress"].toLowerCase()
            const password = formFields['password']
            const command = new InitiateAuthCommand({
                AuthFlow: "USER_PASSWORD_AUTH",
                ClientId: CloudformationOutputs['UserPoolClientId'],
                AuthParameters: {
                    USERNAME: username,
                    PASSWORD: password,
                }
            })
            client.send(command)
                .then((data: any) => {

                    const idTokenFromCognito = data.AuthenticationResult?.IdToken
                    const accessTokenFromCognito = data.AuthenticationResult?.AccessToken
                    const refreshTokenFromCognito = data.AuthenticationResult?.RefreshToken

                    // if there is a refresh token, save it locally
                    if (refreshTokenFromCognito) {
                        //console.log(`🥬 saving refresh token: ${refreshTokenFromCognito}`)
                        localStorage.setItem('localRefreshToken', refreshTokenFromCognito)
                    }

                    // handle new password required
                    if (
                        data.ChallengeName === "NEW_PASSWORD_REQUIRED" &&
                        data.ChallengeParameters &&
                        data.ChallengeParameters.USER_ID_FOR_SRP
                    ) {
                        //! HANDLE SETTING A NEW PASSWORD
                        console.log("New password required")
                        setShowModal(null)
                        setShowLoginModal(false)
                        setAuthChallenge(data)
                    }

                    // handle sucessful login
                    else if (idTokenFromCognito && accessTokenFromCognito) {
                        const payloadObj: { [index: string]: string } = {
                            action: "login",
                            loggingInFromApp: "mobilechecklist",
                            idToken: idTokenFromCognito,
                            accessToken: accessTokenFromCognito
                        }
                        const payload = JSON.stringify(payloadObj)
                        //console.log(`sending tokens to websocket`)
                        localStorage.setItem('localIdToken', idTokenFromCognito)
                        localStorage.setItem('localAccessToken', accessTokenFromCognito)
                        sendMessageToWebsocket(payload)
                    } else {
                        console.log("Login failed: No tokens received")
                        setShowLoginModal(false)
                        setShowModal({ "error": "Login failed: No tokens received" })
                    }
                })
                .catch((error: any) => {
                    setShowModal(null)
                    setShowLoginModal(false)
                    console.error("Login failed", error)
                    setShowModal({ "error": "Invalid login credentials. Please try again." })
                })
        }
    }




    return <div className={`w-full flex flex-col gap-4`}>

        <h3 className={`font-righteous text-2xl text-brand-dark`}>Log in</h3>

        <Text
            labelText={'Email address'}
            formFields={formFields}
            setFormFields={setFormFields}
            formErrors={formErrors}
            fieldName={'emailAddress'}
            required={true}
            size={'big'}
            center={true}
        />

        <Password
            labelText={'Password'}
            formFields={formFields}
            formErrors={formErrors}
            setFormFields={setFormFields}
            fieldName={'password'}
            required={true}
            size={'big'}
            center={true}
        />

        <div className={`w-full flex flex-row gap-4`}>
            <Button
                onClick={() => setShowForm(null)}
                text={'Cancel'}
                variant={'gray'}
                size={'big'}
                sameWindow={true}
            />
            <Button
                onClick={validateAndSave}
                text={'Continue'}
                size={'big'}
                sameWindow={true}
                disabled={!socket || !formFields['emailAddress'] || !formFields['password']}
                variant={socket ? 'secondary' : 'gray'}
                id={socket ? `continueButton` : 'inactive'}
            />
        </div>

        <Link to={`/forgotPassword`} className={`mb-4 text-sm underline hover:opacity-80 cursor-pointer`}>Forgot your password?</Link>
    </div>
}
export default LoginForm